import { render, staticRenderFns } from "./LinkedStarts.vue?vue&type=template&id=1d811233&scoped=true&"
import script from "./LinkedStarts.vue?vue&type=script&lang=js&"
export * from "./LinkedStarts.vue?vue&type=script&lang=js&"
import style0 from "./LinkedStarts.vue?vue&type=style&index=0&id=1d811233&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d811233",
  null
  
)

export default component.exports